import {
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-sails/core';
import {
    State,
    mapStateToProps,
} from './selector';
import saga from './saga';
import lmReducer from './reducer';
import {
    Cookies,
    Namespace,
} from '../../enum';
import { mountTextLink } from '../../components/textLink';
import { mountButton } from '../../components/button';
import { LmModuleId } from '../../enums/elementId';
import { setOverlayVisibility } from '../Overlay/action';
import * as lmFormActions from '../LeadManagementForm/action';
import { OverlayContent } from '../Overlay/enum';
import { mountNotification } from '../../components/notification';
import { LmFormId } from '../../enums/elementId';
import { getUpdateFlags } from './update';
import {
    getSuccessNotificationProps,
    getErrorNotificationProps,
} from '../../util/components/notification.util';
import { setElementVisibility } from '../../../app/util/visibility';
import { mountFormElement } from '../../components/formElement';
import {
    defaultValidation,
    emailValidation,
} from '../../util/validator';
import { formValidation } from '@vfde-brix/ws10/validation';
import { getCookie } from '@vfde-sails/utils';

const mapDispatch = {
    ...lmFormActions,
    setOverlayVisibility,
};

type Actions = typeof mapDispatch;

function container (state: State, actions: Actions) {
    injectSaga(Namespace.LM, saga);
    injectReducer(Namespace.LM, lmReducer);

    mountTextLink(LmModuleId.REGISTER_LINK, () => actions.setOverlayVisibility(true, OverlayContent.LM_FORM));
    const successNotification = mountNotification(LmFormId.SUCCESS_NOTIFICATION);
    const errorNotification = mountNotification(LmFormId.ERROR_NOTIFICATION);

    const titleOnChange = (value: string) => actions.changeLmInput({ salutation: value });
    const firstNameOnChange = (value: string) => actions.changeLmInput({ firstName: value });
    const lastNameOnChange = (value: string) => actions.changeLmInput({ lastName: value });
    const emailOnChange = (value: string) => actions.changeLmInput({ email: value });

    const titleInput = mountFormElement(LmFormId.FORM_INPUT_TITLE, titleOnChange, []);
    const firstNameInput = mountFormElement(LmFormId.FORM_INPUT_FIRSTNAME, firstNameOnChange, defaultValidation);
    const lastNameInput = mountFormElement(LmFormId.FORM_INPUT_LASTNAME, lastNameOnChange, defaultValidation);
    const emailInput = mountFormElement(LmFormId.FORM_INPUT_EMAIL, emailOnChange, emailValidation);
    const submitButton = mountButton(LmFormId.FORM_BUTTON, actions.submitLmForm);

    if (titleInput && firstNameInput && lastNameInput && emailInput && submitButton) {
        formValidation({
            formFields: [titleInput, firstNameInput, lastNameInput, emailInput],
            submitButton,
        }, true, true);
    }

    if (state.isAvailabilityChecked && state.availability) {
        setElementVisibility(LmModuleId.MODULE_CONTAINER, !!getCookie(Cookies.ZHP_LM_MODULE) && !state.availability.fiber);
    }

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            const update = getUpdateFlags(newState, oldState);
            const { responseData, lmError, isAvailabilityChecked, availability } = newState;

            if (update.avc) {
                setElementVisibility(
                    LmModuleId.MODULE_CONTAINER,
                    !!getCookie(Cookies.ZHP_LM_MODULE) && isAvailabilityChecked && !availability?.fiber,
                );
            }

            if (update.lmResult && responseData) {
                successNotification?.update(getSuccessNotificationProps());
                setElementVisibility(LmFormId.SUCCESS_NOTIFICATION, true);
                setElementVisibility(LmFormId.FORM, false);
                setElementVisibility(LmModuleId.MODULE_SUCCESS_CONTAINER, true);
                setElementVisibility(LmModuleId.MODULE_CONTAINER, false);
            }

            if (update.lmError && lmError) {
                errorNotification?.update(getErrorNotificationProps(lmError));
                setElementVisibility(LmFormId.ERROR_NOTIFICATION, true);
            }
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(container);
